import React from 'react';
import { EditorTab } from '@/types';
import { getFileIcon } from '@/utils/fileUtils';
import { X } from 'lucide-react';

interface EditorTabsProps {
  tabs: EditorTab[];
  activeTabId: string | null;
  onTabSelect: (tabId: string) => void;
  onTabClose: (tabId: string) => void;
}

const EditorTabs: React.FC<EditorTabsProps> = ({
  tabs,
  activeTabId,
  onTabSelect,
  onTabClose,
}) => {
  const handleTabClose = (e: React.MouseEvent, tabId: string) => {
    e.stopPropagation();
    onTabClose(tabId);
  };

  if (tabs.length === 0) {
    return (
      <div className="bg-gray-800 border-b border-gray-700 h-10 flex items-center px-4">
        <span className="text-sm text-gray-400">No files open</span>
      </div>
    );
  }

  return (
    <div className="bg-gray-800 border-b border-gray-700 flex overflow-x-auto">
      {tabs.map((tab) => (
        <div
          key={tab.id}
          className={`
            flex items-center space-x-2 px-3 py-2 border-r border-gray-700 cursor-pointer
            min-w-0 max-w-xs group
            ${tab.id === activeTabId 
              ? 'bg-gray-700 text-white' 
              : 'bg-gray-800 text-gray-300 hover:bg-gray-750'
            }
          `}
          onClick={() => onTabSelect(tab.id)}
        >
          {/* File Icon */}
          <span className="flex-shrink-0 text-sm">
            {getFileIcon(tab.name)}
          </span>
          
          {/* File Name */}
          <span className="truncate text-sm">
            {tab.name}
            {tab.isDirty && <span className="text-orange-400 ml-1">•</span>}
          </span>
          
          {/* Close Button */}
          <button
            onClick={(e) => handleTabClose(e, tab.id)}
            className="flex-shrink-0 p-1 rounded hover:bg-gray-600 opacity-0 group-hover:opacity-100 transition-opacity"
            title="Close tab"
          >
            <X size={12} />
          </button>
        </div>
      ))}
    </div>
  );
};

export default EditorTabs;